<template>
    <div>
        <div class="main-container-misc">
            <h3 class="main-container-misc-title py-3 px-4 font-weight-bold">
                Cuentas Contables Automáticas
            </h3>
            <template>
                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-2>
                    <v-flex xs4 md1>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon customers-icon"></i>
                            Clientes
                        </div>
                    </v-flex>
                    <v-flex xs8 md7>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="customersAccount"
                                    :label="customers"
                                    @open-searcher="openSearcher(customers, 'customers')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs3 md1>
                        <BaseInput
                            class="baseAccount"
                            readonly
                            :height="30"
                            v-model="customers"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsign">
                        <app-button
                            green
                            text="Asignar"
                            width="80"
                            @click="asignCustomer"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsignMovil">
                        <app-tooltip-button
                            img="/static/img/icons/to-declare.svg"
                            text="Asignar"
                            :width="20"
                            @click-icon="asignCustomer"
                        />
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-2>
                    <v-flex xs4 md1>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon suppliers-icon"></i>
                            Proveedores
                        </div>
                    </v-flex>
                    <v-flex xs8 md7>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="suppliersAccount"
                                    :label="suppliers"
                                    @open-searcher="openSearcher(suppliers, 'suppliers')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs3 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            v-model="suppliers"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsign">
                        <app-button
                            green
                            text="Asignar"
                            width="80"
                            @click="asignSuppliers"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsignMovil">
                        <app-tooltip-button
                            img="/static/img/icons/to-declare.svg"
                            text="Asignar"
                            :width="20"
                            @click-icon="asignSuppliers"
                        />
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-2>
                    <v-flex xs4 md1>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon cash-icon"></i>
                            Cajas
                        </div>
                    </v-flex>
                    <v-flex xs8 md7>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="cashAccount"
                                    :label="cash"
                                    @open-searcher="openSearcher(cash, 'cash')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs3 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            v-model="cash"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsign">
                        <app-button
                            green
                            text="Asignar"
                            width="80"
                            @click="asignCash"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsignMovil">
                        <app-tooltip-button
                            img="/static/img/icons/to-declare.svg"
                            text="Asignar"
                            :width="20"
                            @click-icon="asignCash"
                        />
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-2>
                    <v-flex xs4 md1>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon bank-icon"></i>
                            Bancos
                        </div>
                    </v-flex>
                    <v-flex xs8 md7>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    :height="30"
                                    :value="bankAccount"
                                    :label="bank"
                                    @open-searcher="openSearcher(bank, 'bank')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs3 md1>
                        <BaseInput
                            class="baseAccount"
                            :height="30"
                            v-model="bank"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsign">
                        <app-button
                            green
                            text="Asignar"
                            width="80"
                            @click="asignBank('bank')"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsignMovil">
                        <app-tooltip-button
                            img="/static/img/icons/to-declare.svg"
                            text="Asignar"
                            :width="20"
                            @click-icon="asignBank('bank')"
                        />
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-3>
                    <v-flex xs4 md1>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon cheques-icon"></i>
                            Cheques
                        </div>
                    </v-flex>
                    <v-flex xs8 md7>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="chequeAccount"
                                    :label="cheque"
                                    @open-searcher="openSearcher(cheque, 'cheque')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs3 md1>
                        <BaseInput
                            class="baseAccount"
                            :height="30"
                            v-model="cheque"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsign">
                        <app-button
                            green
                            text="Asignar"
                            width="80"
                            @click="asignBank('check')"
                        />
                    </v-flex>
                    <v-flex xs1 md1 text-xs-center class="btnAsignMovil">
                        <app-tooltip-button
                            img="/static/img/icons/to-declare.svg"
                            text="Asignar"
                            :width="20"
                            @click-icon="asignBank('check')"
                        />
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>
            </template>

            <template>
                <v-layout wrap align-center justify-center pt-2 mx-2 mb-2>
                    <v-flex xs12 mt-2 text-xs-center>
                        <app-button
                            green
                            text="Asignar a todas las cuentas contables"
                            width="280"
                            @click="asignMisc"
                        />
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout v-if="this.currentSubsidiary.typeCompany !== 1" wrap align-center justify-space-between pt-3 mx-4 mb-3>
                    <v-flex xs7 md1 mb-3>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon inventory-icon"></i>
                            Artículos Inventarios
                        </div>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Con Iva"
                            v-model="ivaInvCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4 mb-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="ivaInvName"
                                    :label="ivaInv"
                                    @open-searcher="openSearcher(ivaInv, 'ivaInventory')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Sin Iva"
                            v-model="withoutIvaInviCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :label="withoutIvaInvi"
                                    :value="withoutIvaInviName"
                                    @open-searcher="openSearcher(withoutIvaInvi, 'withoutIvaInventory')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout v-if="this.currentSubsidiary.typeCompany !== 1" wrap align-center justify-space-between pt-3 mx-4 mb-3>
                    <v-flex xs7 md1 mb-3>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon costs-icon"></i>
                            Artículos Costos
                        </div>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Con Iva"
                            v-model="ivaCostsCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4 mb-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="ivaCostsName"
                                    :label="ivaCosts"
                                    @open-searcher="openSearcher(ivaCosts, 'ivaCosts')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Sin Iva"
                            v-model="withoutIvaCostsCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="withoutIvaCostsName"
                                    :label="withoutIvaCosts"
                                    @open-searcher="openSearcher(withoutIvaCosts, 'withoutIvaCosts')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-3>
                    <v-flex xs7 md1 mb-3>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon sales-icon"></i>
                            Artículos Ventas
                        </div>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            v-model="ivaSalesCode"
                            label="Cta. Contable Con Iva"
                        />
                    </v-flex>
                    <v-flex xs12 md4 mb-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="ivaSalesName"
                                    :label="ivaSales"
                                    @open-searcher="openSearcher(ivaSales, 'ivaSales')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Sin Iva"
                            v-model="withoutIvaSalesCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="withoutIvaSalesName"
                                    :label="withoutIvaSales"
                                    @open-searcher="openSearcher(withoutIvaSales, 'withoutIvaSales')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-3>
                    <v-flex xs7 md1 mb-3>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon discount-icon"></i>
                            Artículos Descuentos
                        </div>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable con Iva"
                            v-model="ivaDiscountCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4 mb-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="ivaDiscountName"
                                    :label="ivaDiscount"
                                    @open-searcher="openSearcher(ivaDiscount, 'ivaDiscount')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Sin Iva"
                            v-model="withoutIvaDiscountCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="withoutIvaDiscountName"
                                    :label="withoutIvaDiscount"
                                    @open-searcher="openSearcher(withoutIvaDiscount, 'withoutIvaDiscount')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-3>
                    <v-flex xs7 md1 mb-3>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon returns-icon"></i>
                            Artículos Devoluciones
                        </div>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Con Iva"
                            v-model="ivaRepaymentCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4 mb-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="ivaRepaymentName"
                                    :label="ivaRepayment"
                                    @open-searcher="openSearcher(ivaRepayment, 'ivaRepayment')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Sin Iva"
                            v-model="withoutIvaRepaymentCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="withoutIvaRepaymentName"
                                    :label="withoutIvaRepayment"
                                    @open-searcher="openSearcher(withoutIvaRepayment, 'withoutIvaRepayment')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout v-if="this.currentSubsidiary.typeCompany !== 1" wrap align-center justify-space-between pt-3 mx-4 mb-4>
                    <v-flex xs7 md1 mb-3>
                        <label class="caption">Tipo de Entidad</label>
                        <div class="entity-name">
                            <i class="entity-icon process-icon"></i>
                            Artículos Procesos
                        </div>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Con Iva"
                            v-model="ivaProccessCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4 mb-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="ivaProccessName"
                                    :label="ivaProccess"
                                    @open-searcher="openSearcher(ivaProccess, 'ivaProccess')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 md1>
                        <BaseInput
                            readonly
                            class="baseAccount"
                            :height="30"
                            label="Cta. Contable Sin Iva"
                            v-model="withoutIvaProccessCode"
                        />
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <label class="caption">Nombre de Cta. Contable</label>
                            </v-flex>
                            <v-flex xs12>
                                <input-searcher
                                    readonly
                                    :height="30"
                                    :value="withoutIvaProccessName"
                                    :label="withoutIvaProccess"
                                    @open-searcher="openSearcher(withoutIvaProccess, 'withoutIvaProccess')"
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>

                <v-layout wrap align-center justify-space-between pt-3 mx-4 mb-4></v-layout>
                <v-divider></v-divider>
            </template>

            <v-layout wrap align-center justify-center class="button-actions" mt-5>
                <v-flex text-xs-center>
                    <app-button
                        red
                        text="Cancelar"
                        width="80"
                        v-if="!hidden"
                    />
                    <app-button
                        green
                        text="Guardar"
                        width="80"
                        @click="onEditMiscOneMod"
                    />
                </v-flex>
            </v-layout>

            <action-sidebar
                :title="action.title"
                :value="action.value"
                :width="action.width"
                @close-modal="closeModal"
            >
                <slide-searcher
                    v-if="isActionCode('searcher')"
                    :columns="columns"
                    :current-page="currentPage"
                    :last-page="lastPage"
                    :rows="records"
                    @add-record="addRecord"
                    @on-close="closeModal"
                    @on-page="changePage"
                    @on-search="onSearchRecords"
                />
            </action-sidebar>
        </div>
    </div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import inputSearcher from '@/components/shared/searcher/input-searcher';
	import slideSearcher from '@/components/shared/searcher/slide-searcher';
	import appInputText from '@/components/autocomplete/app-input-text';
	import { mapGetters } from 'vuex';
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function accountDataName({ accountData }) {
		return accountData ? accountData.name : accountData;
	}

	function accountAlternateName({ accountDataAlternate }) {
		return accountDataAlternate ? accountDataAlternate.name : accountDataAlternate;
	}

	function addRecord(record) {
		if (this.prop === 'account' || this.prop === 'accountData' || this.prop === 'accountDataAlternate') {
			const newProp = this.prop === 'account' ? 'accountData' : 'accountDataAlternate';
			this.$set(this.rowSelected, this.prop, record.account);
			this.$set(this.rowSelected, newProp, record);
			this.action.value = false;
			this.action.title = '';
			this.action.code = '';
		} else {
			if (this.prop === 'ivaInventory') {
				this.ivaInv = record.id;
				this.ivaInvCode = record.account;
				this.ivaInvName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
			}
			if (this.prop === 'withoutIvaInventory') {
				this.withoutIvaInvi = record.id;
				this.withoutIvaInviCode = record.account;
				this.withoutIvaInviName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'ivaSales') {
				this.ivaSales = record.id;
				this.ivaSalesCode = record.account;
				this.ivaSalesName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'withoutIvaSales') {
				this.withoutIvaSales = record.id;
				this.withoutIvaSalesCode = record.account;
				this.withoutIvaSalesName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'ivaProccess') {
				this.ivaProccess = record.id;
				this.ivaProccessCode = record.account;
				this.ivaProccessName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'withoutIvaProccess') {
				this.withoutIvaProccess = record.id;
				this.withoutIvaProccessCode = record.account;
				this.withoutIvaProccessName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'ivaDiscount') {
				this.ivaDiscount = record.id;
				this.ivaDiscountCode = record.account;
				this.ivaDiscountName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'withoutIvaDiscount') {
				this.withoutIvaDiscount = record.id;
				this.withoutIvaDiscountCode = record.account;
				this.withoutIvaDiscountName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'ivaCosts') {
				this.ivaCosts = record.id;
				this.ivaCostsCode = record.account;
				this.ivaCostsName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'withoutIvaCosts') {
				this.withoutIvaCosts = record.id;
				this.withoutIvaCostsCode = record.account;
				this.withoutIvaCostsName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'ivaRepayment') {
				this.ivaRepayment = record.id;
				this.ivaRepaymentCode = record.account;
				this.ivaRepaymentName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'withoutIvaRepayment') {
				this.withoutIvaRepayment = record.id;
				this.withoutIvaRepaymentCode = record.account;
				this.withoutIvaRepaymentName = record.name;
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
				this.onEditMiscOneMod();
			}
			if (this.prop === 'customers') {
				this.customers = record.account;
				this.customersAccount = record.name;
				this.customersId = record.id;
				this.customerCode = record.code;
				this.customersName = 'Clientes';
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
			}
			if (this.prop === 'suppliers') {
				this.suppliers = record.account;
				this.suppliersId = record.id;
				this.suppliersAccount = record.name;
				this.suplliersCode = record.code;
				this.suppliersName = 'Proveedores';
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
			}
			if (this.prop === 'cash') {
				this.cashId = record.id;
				this.cash = record.account;
				this.cashAccount = record.name;
				this.cashName = 'caja';
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
			}
			if (this.prop === 'bank') {
				this.bank = record.account;
				this.bankId = record.id;
				this.bankAccount = record.name;
				this.bankNAme = 'banco';
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
			}
			if (this.prop === 'cheque') {
				this.cheque = record.account;
				this.chequeId = record.id;
				this.chequeAccount = record.name;
				this.chequeNAme = 'cheque';
				this.action.value = false;
				this.action.title = '';
				this.action.code = '';
			}
		}
	}
	async function asignMisc() {
		const inventory = {
			iva: this.ivaInv || '',
			withoutIva: this.withoutIvaInvi || '',
		};
		const costs = {
			iva: this.ivaCosts || '',
			withoutIva: this.withoutIvaCosts || '',
		};
		const sales = {
			iva: this.ivaSales || '',
			withoutIva: this.withoutIvaSales || '',
		};
		const process = {
			iva: this.ivaProccess || '',
			withoutIva: this.withoutIvaProccess || '',
		};
		const repayment = {
			iva: this.ivaRepayment || '',
			withoutIva: this.withoutIvaRepayment || '',
		};
		const discount = {
			iva: this.ivaDiscount || '',
			withoutIva: this.withoutIvaDiscount || '',
		};

		const accountingAccount = {
			inventory,
			costs,
			sales,
			process,
			repayment,
			discount,
		};
		this.accountingAccount = {
			accountingAccount,
		};
		// const flagForceUpdate = this.flagForceUpdate;
		const token = JSON.parse(localStorage.getItem('cs'));
		try {
			// await this.$httpProducts.patch(`products/accounting-account
			// ?flagForceUpdate=${flagForceUpdate}&externalId=${this.externalId}`, this.accountingAccount,
			await this.$httpProducts.patch(`products/accounting-account?flagForceUpdate=${true}`, this.accountingAccount,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.loadData('type-register');
			this.onEditMiscOneMod();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function created() {
		// const dataUserInfo = typeof this.$userInfo === 'string'
		// ? JSON.parse(this.$userInfo) : this.$userInfo;
		// this.externalId = dataUserInfo.subsidiary ? dataUserInfo.subsidiary.externalId : null;
		this.newData = this.rows;
		this.loadSettings();
	}

	// function changeButton() {
	// 	const dataSet = null;
	// 	if (dataSet == null || dataSet === {}) {
	// 		this.flagButton = false;
	// 	} else {
	// 		this.flagButton = true;
	// 	}
	// }

	function changePage(page) {
		this.loadRecords(page);
	}

	function closeModal() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		delete this.recordsParams.search;
	}

	async function loadSettings() {
		const { customerId, subsidiaryId } = this.$route.query;
		try {
			const { data: response } = await this.$http.get(`settings/${customerId}/${subsidiaryId}`);
			console.log('response::: ', response);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.productSettings = response.settings || {};
			this.ivaInv = response.productsSettings.inventory ?
				response.productsSettings.inventory.iva : null;
			this.withoutIvaInvi = response.productsSettings.inventory ?
				response.productsSettings.inventory.withoutIva : null;
			this.ivaCosts = response.productsSettings.costs ?
				response.productsSettings.costs.iva : null;
			this.withoutIvaCosts = response.productsSettings.costs ?
				response.productsSettings.costs.withoutIva : null;
			this.ivaSales = response.productsSettings.sales ?
				response.productsSettings.sales.iva : null;
			this.withoutIvaSales = response.productsSettings.sales ?
				response.productsSettings.sales.withoutIva : null;
			this.ivaProccess = response.productsSettings.process ?
				response.productsSettings.process.iva : null;
			this.withoutIvaProccess = response.productsSettings.process ?
				response.productsSettings.process.withoutIva : null;
			this.ivaRepayment = response.productsSettings.repayment ?
				response.productsSettings.repayment.iva : null;
			this.withoutIvaRepayment = response.productsSettings.repayment ?
				response.productsSettings.repayment.withoutIva : null;
			this.ivaDiscount = response.productsSettings.discount ?
				response.productsSettings.discount.iva : null;
			this.withoutIvaDiscount = response.productsSettings.discount ?
				response.productsSettings.discount.withoutIva : null;
			this.customersAccount = response.settings[0].customers.accountName;
			this.customers = response.settings[0].customers.account;
			this.suppliersAccount = response.settings[0].suppliers.accountName;
			this.suppliers = response.settings[0].suppliers.account;
			this.cashAccount = response.settings[0].cash.accountName;
			this.cash = response.settings[0].cash.account;
			this.chequeAccount = response.settings[0].cheque.accountName;
			console.log('this.chequeAccount::: ', this.chequeAccount);
			this.cheque = response.settings[0].cheque.account;
			console.log('this.cheque::: ', this.cheque);
			this.bankAccount = response.settings[0].bank.accountName;
			console.log('this.bankAccount::: ', this.bankAccount);
			this.bank = response.settings[0].bank.account;
			console.log('this.bank::: ', this.bank);
			this.loadRecords();
			this.showNotification('La configuración de cuentas contables cargada.');
			this.params.subsidiaryId = null;
			this.dataSetting = response.settings;
			this.dataNewSetting = this.dataSetting;
			this.newData = this.newData.map((r) => {
				const nb = { ...r };
				this.dataNewSetting.forEach((p) => {
					if (r.id === p.id) {
						nb.account = p.account;
						nb.accountName = p.accountName;
					}
				});
				return nb;
			});
			if (!response) {
				this.flagButton = false;
			} else {
				this.flagButton = true;
			}
		} catch (err) {
			console.log('err::: ', err);
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function isActionCode(code) {
		return this.action.code === code;
	}

	async function loadRecords(page = 1) {
		const { subsidiaryId } = this.$route.query;
		this.currentPage = page;
		this.recordsParams.page = page;
		try {
			const { data: records, headers } = await this.$http.get(`accounting-plan/${subsidiaryId}/subsidiary`,
				{ params: this.recordsParams });
			const { data: records1 } = await this.$http.get(`accounting-plan/${subsidiaryId}/subsidiary`,
				{ params: this.recordsParams.status });
			this.lastPage = Number(headers['x-last-page']);
			this.records = [...records];
			this.records1 = [...records1];
			const ivaInvi = records1.find(mod => mod.id === this.ivaInv);
			const ivaWithOutInvi = records1.find(mod => mod.id === this.withoutIvaInvi);
			const ivaCosts = records1.find(mod => mod.id === this.ivaCosts);
			const withoutIvaCosts = records1.find(mod => mod.id === this.withoutIvaCosts);
			const ivaSales = records1.find(mod => mod.id === this.ivaSales);
			const withoutIvaSales = records1.find(mod => mod.id === this.withoutIvaSales);
			const ivaProccess = records1.find(mod => mod.id === this.ivaProccess);
			const withoutIvaProccess = records1.find(mod => mod.id === this.withoutIvaProccess);
			const ivaRepayment = records1.find(mod => mod.id === this.ivaRepayment);
			const withoutIvaRepayment = records1.find(mod => mod.id === this.withoutIvaRepayment);
			const ivaDiscount = records1.find(mod => mod.id === this.ivaDiscount);
			const withoutIvaDiscount = records1.find(mod => mod.id === this.withoutIvaDiscount);
			this.ivaInvName = ivaInvi && ivaInvi.name ? ivaInvi.name : null;
			this.ivaInvCode = ivaInvi && ivaInvi.account ? ivaInvi.account : null;
			this.withoutIvaInviName = ivaWithOutInvi && ivaWithOutInvi.name
				? ivaWithOutInvi.name : null;
			this.withoutIvaInviCode = ivaWithOutInvi && ivaWithOutInvi.account
				? ivaWithOutInvi.account : null;
			this.ivaSalesName = ivaSales && ivaSales.name
				? ivaSales.name : null;
			this.ivaSalesCode = ivaSales && ivaSales.account
				? ivaSales.account : null;
			this.withoutIvaSalesName = withoutIvaSales && withoutIvaSales.name
				? withoutIvaSales.name : null;
			this.withoutIvaSalesCode = withoutIvaSales && withoutIvaSales.account
				? withoutIvaSales.account : null;
			this.ivaProccessName = ivaProccess && ivaProccess.name
				? ivaProccess.name : null;
			this.ivaProccessCode = ivaProccess && ivaProccess.account
				? ivaProccess.account : null;
			this.withoutIvaProccessName = withoutIvaProccess && withoutIvaProccess.name
				? withoutIvaProccess.name : null;
			this.withoutIvaProccessCode = withoutIvaProccess && withoutIvaProccess.account
				? withoutIvaProccess.account : null;
			this.ivaDiscountName = ivaDiscount && ivaDiscount.name
				? ivaDiscount.name : null;
			this.ivaDiscountCode = ivaDiscount && ivaDiscount.account
				? ivaDiscount.account : null;
			this.withoutIvaDiscountName = withoutIvaDiscount && withoutIvaDiscount.name
				? withoutIvaDiscount.name : null;
			this.withoutIvaDiscountCode = withoutIvaDiscount && withoutIvaDiscount.account
				? withoutIvaDiscount.account : null;
			this.ivaCostsName = ivaCosts && ivaCosts.name
				? ivaCosts.name : null;
			this.ivaCostsCode = ivaCosts && ivaCosts.account
				? ivaCosts.account : null;
			this.withoutIvaCostsName = withoutIvaCosts && withoutIvaCosts.name
				? withoutIvaCosts.name : null;
			this.withoutIvaCostsCode = withoutIvaCosts && withoutIvaCosts.account
				? withoutIvaCosts.account : null;
			this.ivaRepaymentName = ivaRepayment && ivaRepayment.name
				? ivaRepayment.name : null;
			this.ivaRepaymentCode = ivaRepayment && ivaRepayment.account
				? ivaRepayment.account : null;
			this.withoutIvaRepaymentName = withoutIvaRepayment && withoutIvaRepayment.name
				? withoutIvaRepayment.name : null;
			this.withoutIvaRepaymentCode = withoutIvaRepayment && withoutIvaRepayment.account
				? withoutIvaRepayment.account : null;
		} catch (err) {
			this.showGenericError();
		}
	}
	async function onEditMiscOneMod() {
		this.loading = true;
		const companyId = this.currentSubsidiary.id;
		const { customerId, subsidiaryId } = this.$route.query;
		const inventory = {
			iva: this.ivaInv || '',
			withoutIva: this.withoutIvaInvi || '',
		};
		const costs = {
			iva: this.ivaCosts || '',
			withoutIva: this.withoutIvaCosts || '',
		};
		const sales = {
			iva: this.ivaSales || '',
			withoutIva: this.withoutIvaSales || '',
		};
		const process = {
			iva: this.ivaProccess || '',
			withoutIva: this.withoutIvaProccess || '',
		};
		const repayment = {
			iva: this.ivaRepayment || '',
			withoutIva: this.withoutIvaRepayment || '',
		};
		const discount = {
			iva: this.ivaDiscount || '',
			withoutIva: this.withoutIvaDiscount || '',
		};
		const productsSettings = {
			inventory,
			costs,
			sales,
			process,
			repayment,
			discount,
		};
		const suppliers = {
			id: this.suppliersId,
			account: this.suppliers,
			accountName: this.suppliersAccount,
		};
		const customers = {
			id: this.customersId,
			account: this.customers,
			accountName: this.customersAccount,
		};
		const bank = {
			id: this.bankId,
			account: this.bank,
			accountName: this.bankAccount,
		};
		const cheque = {
			id: this.chequeId,
			account: this.cheque,
			accountName: this.chequeAccount,
		};
		const cash = {
			id: this.cashId,
			account: this.cash,
			accountName: this.cashAccount,
		};
		const settings = [{
			suppliers,
			customers,
			cash,
			bank,
			cheque,
		}];
		const newData = {
			subsidiaryId,
			customerId,
			settings,
			companyId,
			productsSettings,
		};
		try {
			await this.$http.patch(`settings/${customerId}/${subsidiaryId}`, newData);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.params.subsidiaryId = null;
			this.loadData('type-register');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function onSearchRecords(searchTable) {
		this.recordsParams.search = searchTable ? searchTable.trim() : null;
		this.loadRecords();
	}

	function openSearcher(row, prop) {
		this.action.title = 'Buscar Cuenta Contable';
		this.action.code = 'searcher';
		this.action.width = 550;
		this.action.value = true;
		this.rowSelected = row;
		this.prop = prop;
		this.loadRecords();
	}
	async function asignCustomer() {
		const code = this.customerCode;
		const id = this.customersId;
		// const flagForceUpdate = this.flagForceUpdateCust;
		const accountingCode = code;
		this.customerParams = {
			accountingCode,
			accountingAccount: { id },
		};
		const token = JSON.parse(localStorage.getItem('cs'));
		try {
			// await this.$httpSales.patch(`customers/accounting-code
			// ?flagForceUpdate=${flagForceUpdate}&externalId=${this.externalId}`, this.customerParams,
			await this.$httpSales.patch(`customers/accounting-code?flagForceUpdate=${true}`, this.customerParams,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.loadData('type-register');
			this.onEditMiscOneMod();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	async function asignCash() {
		const accountingAccount = {
			id: this.cashId,
			name: this.cashAccount,
			account: this.cash,
		};
		// const flagForceUpdate = this.flagForceUpdateCash;
		const token = JSON.parse(localStorage.getItem('cs'));
		try {
			// await this.$httpSales.patch(`cash/accounting-account
			// ?flagForceUpdate=${flagForceUpdate}&externalId=${this.externalId}`, { accountingAccount },
			await this.$httpSales.patch(`cash/accounting-account?flagForceUpdate=${true}`, { accountingAccount },
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.loadData('type-register');
			this.onEditMiscOneMod();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}
	async function asignBank(code) {
		const accountingAccount = {};
		let flagForceUpdate = null;
		let check = null;
		let bank = null;
		if (this.cheque && !this.chequeId) {
			console.log('!this.chequeId::: ', !this.chequeId);
			console.log('this.chequeAccount::: ', this.chequeAccount);
			check = this.records1.find(r => r.account === this.cheque).id;
		}
		if (this.bank && !this.bankId) {
			bank = this.records1.find(r => r.account === this.bank).id;
		}
		console.log('check::: ', check);
		console.log('bank::: ', bank);
		if (code === 'bank') {
			accountingAccount.codeBank =
				this.bank && !this.bankId ? bank : this.bankId || null;
			accountingAccount.codeCheck =
				this.cheque && !this.chequeId ? check : this.chequeId || null;
			flagForceUpdate = true;
		} else {
			accountingAccount.codeBank =
				this.bank && !this.bankId ? bank : this.bankId || null;
			accountingAccount.codeCheck =
				this.cheque && !this.chequeId ? check : this.chequeId || null;
			flagForceUpdate = true;
		}
		const token = JSON.parse(localStorage.getItem('cs'));
		try {
			await this.$httpSales.patch(`bank-accounting-account?flagForceUpdate=${flagForceUpdate}`, { accountingAccount },
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.loadData('type-register');
			this.onEditMiscOneMod();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}
	async function asignSuppliers() {
		const accountingAccount = {
			id: this.suppliersId,
			name: this.suppliersAccount,
		};
		const accountingCode = this.suplliersCode;
		this.suppliersParams = {
			accountingAccount,
			accountingCode,
		};
		// const flagForceUpdate = this.flagForceUpdateSupp;
		const token = JSON.parse(localStorage.getItem('cs'));
		try {
			// await this.$httpSales.patch(`suppliers/accounting-account
			// ?flagForceUpdate=${flagForceUpdate}&externalId=${this.externalId}`, this.suppliersParams,
			await this.$httpSales.patch(`suppliers/accounting-account?flagForceUpdate=${true}`, this.suppliersParams,
				{ headers: { Authorization: `Bearer ${token.filters.aclCredentials.company.hash}` } },
			);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.loadData('type-register');
			this.onEditMiscOneMod();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function currentSubsidiary() {
		this.$emit('reload-misc');
	}

	function data() {
		return {
			action: {
				code: '',
				title: '',
				value: false,
			},
			columns: [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Cuenta', value: 'account', checked: true, visible: true },
				{ id: 3, name: 'Nombre', value: 'name', checked: true, visible: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
			hidden: true,
			lastPage: 0,
			accountingAccount: {},
			ivaInv: '',
			ivaInvCode: '',
			ivaInvName: '',
			withoutIvaInvi: '',
			withoutIvaInviCode: '',
			withoutIvaInviName: '',
			ivaCosts: '',
			ivaCostsCode: '',
			ivaCostsName: '',
			withoutIvaCosts: '',
			withoutIvaCostsCode: '',
			withoutIvaCostsName: '',
			ivaSales: '',
			ivaSalesCode: '',
			ivaSalesName: '',
			withoutIvaSales: '',
			withoutIvaSalesCode: '',
			withoutIvaSalesName: '',
			ivaRepayment: '',
			ivaRepaymentCode: '',
			ivaRepaymentName: '',
			withoutIvaRepayment: '',
			withoutIvaRepaymentCode: '',
			withoutIvaRepaymentName: '',
			ivaDiscount: '',
			ivaDiscountCode: '',
			flagForceUpdate: false,
			ivaDiscountName: '',
			withoutIvaDiscount: '',
			withoutIvaDiscountCode: '',
			withoutIvaDiscountName: '',
			ivaProccess: '',
			ivaProccessCode: '',
			ivaProccessName: '',
			withoutIvaProccess: '',
			withoutIvaProccessCode: '',
			withoutIvaProccessName: '',
			customers: '',
			bankId: '',
			chequeId: '',
			customersAccount: '',
			customersName: '',
			customerCode: '',
			customersId: '',
			customerParams: '',
			suppliers: '',
			suppliersAccount: '',
			suppliersName: '',
			suplliersCode: '',
			suppliersId: '',
			suppliersParams: {},
			bank: '',
			bankAccount: '',
			bankName: '',
			cheque: '',
			chequeAccount: '',
			chequeName: '',
			cash: '',
			cashId: '',
			cashAccount: '',
			cashName: '',
			productSettings: {},
			prop: '',
			records: [],
			records1: [],
			flagForceUpdateChe: false,
			flagForceUpdateBank: false,
			flagForceUpdateCash: false,
			flagForceUpdateSupp: false,
			flagForceUpdateCust: false,
			recordsParams: {
				limit: 20,
				page: 1,
				status: 1,
			},
			rowSelected: {},
			dataSetting: {},
			flagButton: false,
			dataNewSetting: {},
			neWData: [],
			// externalId: null,
		};
	}

	export default {
		name: 'accounting-parametrization-misc-one',
		components: {
			actionSidebar,
			appButton: () => import('@/components/shared/app-button'),
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			inputSearcher,
			slideSearcher,
			appInputText,
			appTooltipButton,
		},
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
			// changeButton,
		},
		created,
		data,
		methods: {
			accountDataName,
			accountAlternateName,
			addRecord,
			changePage,
			closeModal,
			isActionCode,
			loadRecords,
			onSearchRecords,
			openSearcher,
			loadSettings,
			onEditMiscOneMod,
			asignCustomer,
			asignMisc,
			asignCash,
			asignBank,
			asignSuppliers,
		},
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
			rows: {
				default: () => [],
				type: Array,
			},
		},
		watch: {
			currentSubsidiary,
		},
	};
</script>

<style lang="scss" scoped>
.main-container-misc-title {
    background-color: PowderBlue !important;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

.entity-container {
    border-bottom: 1px solid color(grey-background);
}

.main-container-misc {
    background-color: white;
    border-radius: 20px;
    font-family: font(AvenirRegular);
    font-size: size(medium);
}

.optionsSettings {
    @media (max-width: 768px) {
        display: none;
    }
}

.entity-name {
    font-family: font(AvenirDemi);
    display: flex;
    align-items: center;
    gap: 8px;
}

.general-accounting {
    background-color: PowderBlue !important;
}

.button-actions {
    background-color: white;
    bottom: 0;
    left: 0;
    padding: 20px 0;
    position: fixed;
    width: 100%;
}

.entity-container1 {
    border-bottom: 1px solid color(grey-background);
    width: 100%;
    @media (max-width: 768px) {
        display: none;
    }
}

.addAccounting {
    @media (max-width: 768px) {
        right: -40px;
        position: relative;
    }
}

.btnAsign {
    @media (max-width: 768px) {
        display: none;
    }
}

.btnAsignMovil {
    display: none;
    @media (max-width: 768px) {
        display: flex;
    }
}

/* Iconos para cada tipo de entidad */
.entity-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
}

.customers-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23667eea"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>');
}

.suppliers-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23f093fb"><path d="M19 7h-3V6a4 4 0 00-8 0v1H5a1 1 0 000 2h1v11a3 3 0 003 3h6a3 3 0 003-3V9h1a1 1 0 000-2zM10 6a2 2 0 014 0v1h-4V6zm4 13h-4v-7h4v7z"/></svg>');
}

.cash-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23ffecd2"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>');
}

.bank-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23a8edea"><path d="M12 3L2 12h3v8h14v-8h3L12 3zm0 2.84L18.16 12H16v6H8v-6H5.84L12 5.84z"/></svg>');
}

.cheques-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23d299c2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zM18 20H6V4h7v5h5v11z"/></svg>');
}

.inventory-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%234facfe"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>');
}

.costs-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fa709a"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>');
}

.sales-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23a8e6cf"><path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>');
}

.discount-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fbc2eb"><path d="M12.79 21L3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.79 21z"/><path d="M11.38 17.41c.39.39.9.59 1.41.59.51 0 1.02-.2 1.41-.59l6.21-6.21c.78-.78.78-2.05 0-2.83L12.62 0.21C12.25-.17 11.74-.38 11.21-.38H4C3.45-.38 3 .07 3 .62v7.21c0 .53.21 1.04.59 1.41l7.79 7.79z"/></svg>');
}

.returns-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fdbb2d"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>');
}

.process-icon {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23ee9ca7"><path d="M12 15.5A3.5 3.5 0 018.5 12 3.5 3.5 0 0112 8.5a3.5 3.5 0 013.5 3.5 3.5 3.5 0 01-3.5 3.5zM19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65z"/></svg>');
}
</style>


// WEBPACK FOOTER //
// src/components/accounting-parametrizations/accounting-parametrization-misc-one.vue